// Login.js
import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../assets/css/login.css";
import logo from "../assets/img/Agrifresh_Logo.png";
import { AuthContext } from "../auth/AuthContext";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (isAuthenticated) navigate("/");
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Username and Password are required!");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/dashboard/login`, { username, password });

      if (res.data.token) {
        login(res.data.token);
        setTimeout(() => {
          navigate("/");
          setLoading(false);
        }, 800);
      } else {
        setLoading(false);
        setError(res.data.message || "Login failed!");
      }
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || "Server error. Please try again later.");
    }
  };

  return (
    <section className="modeva-login">
      <div className="content">
        <figure>
          <img className="logo" src={logo} alt="Modeva Logo" />
        </figure>

        <form onSubmit={handleLogin}>
          <h4>
            <i className="fa fa-user" style={{ color: "#bb1114" }}></i> Please
            enter your login details.
          </h4>

          {error && <p className="error">{error}</p>}

          <ul>
            <li>
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </li>

            <li>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </li>
          </ul>

          <div className="markup-btn w-100 px-3">
            <button type="submit" disabled={loading} className="w-100">
              {loading ? "Logging in...." : "Login"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Login;
